import { cn } from '@/lib/cn'

interface SpecialistToggleProps {
  specialtyLabel: string
  name: string
  isOnCall: boolean
  onToggle: () => void
  onNameChange: (name: string) => void
}

export function SpecialistToggle({ specialtyLabel, name, isOnCall, onToggle, onNameChange }: SpecialistToggleProps) {
  return (
    <div className="flex items-center justify-between py-3 px-4 border-b border-neutral-100 last:border-b-0">
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <button
          type="button"
          onClick={onToggle}
          className={cn(
            'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full transition-colors duration-200',
            isOnCall ? 'bg-success-500' : 'bg-neutral-300'
          )}
        >
          <span
            className={cn(
              'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow-sm transition-transform duration-200 mt-0.5 ml-0.5',
              isOnCall ? 'translate-x-5' : 'translate-x-0'
            )}
          />
        </button>
        <span className="text-sm font-medium text-neutral-900 shrink-0">{specialtyLabel}</span>
      </div>
      {isOnCall && (
        <input
          type="text"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="Nom du praticien"
          className="ml-3 w-40 sm:w-52 text-sm border border-neutral-200 rounded-md px-2.5 py-1.5 text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
        />
      )}
    </div>
  )
}
